import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { FidjiAppDeviceSettingsService } from '@immanens-com/fidji-api-module';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class VersionService {

  private versionSubject = new BehaviorSubject(null);
  public readonly versionChange = this.versionSubject.asObservable();

  private buildNumber: string;
  private versionNumber: string;
  private versionApp: string;

  public get applicationVersion(): string {
    return this.versionApp;
  }

  public get angularVersion(): string {
    return this.versionNumber + '(' + this.buildNumber + ')';
  }

  constructor(
    private http: HttpClient,
    private settingService: FidjiAppDeviceSettingsService) {
      this.defineVersion();
    }

  private defineVersion() {
    this.http.get('imm-hybride.manifest', {responseType: 'text'}).subscribe((file) => {
      const matchBuildNumber = file.match('(VERSION:.)([0-9]+)');
      this.buildNumber = matchBuildNumber[2];
      this.versionSubject.next(null);
    });

    this.versionNumber = environment.VERSION;
    this.versionApp = this.settingService.appSettings.app_version;
    this.versionSubject.next(null);
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/version/version.service.ts